function FavoriteFiltersController($scope, $rootScope, dataHolderFactory, localStorageService) {

  $scope.favoriteFilters = dataHolderFactory.getFavoriteFilters();
  $scope.favoriteFilterSelected = dataHolderFactory.getFavoriteFilterSelected();
  $scope.search = { searchText: '' };

  $scope.selectFavoriteFilter = function(favoriteFilter) {
    dataHolderFactory.updateFavoriteFilterSelected(favoriteFilter);
    $scope.favoriteFilterSelected = favoriteFilter;

    const filterOptions = angular.copy(localStorageService.get('originalFilters'));

    favoriteFilter = favoriteFilter.fields;

    favoriteFilter.documents = favoriteFilter.documents || [];
    angular.forEach(filterOptions.documents, (model) => model.selected = favoriteFilter.documents.includes(model.id));

    favoriteFilter.places = favoriteFilter.places || [];
    angular.forEach(filterOptions.places, (model) => model.selected = favoriteFilter.places.includes(model.id));

    favoriteFilter.status = favoriteFilter.status || [];
    angular.forEach(filterOptions.status, (model) => model.selected = favoriteFilter.status.includes(model.id));

    favoriteFilter.communityAssets = favoriteFilter.communityAssets || [];
    angular.forEach(filterOptions.communityAssets, (model) => model.selected = favoriteFilter.communityAssets.includes(model.id));

    favoriteFilter.organs = favoriteFilter.organs || [];
    angular.forEach(filterOptions.organs, (model) => model.selected = favoriteFilter.organs.includes(model.id));

    favoriteFilter.enterprises = favoriteFilter.enterprises || [];
    angular.forEach(filterOptions.enterprises, (model) => model.selected = favoriteFilter.enterprises.includes(model.id));

    favoriteFilter.programs = favoriteFilter.programs || favoriteFilter.programs;
    angular.forEach(filterOptions.programs, (model) => model.selected = favoriteFilter.programs.includes(model.id));

    favoriteFilter.sectors = favoriteFilter.sectors || [];
    angular.forEach(filterOptions.sectors, (model) => model.selected = favoriteFilter.sectors.includes(model.id));

    favoriteFilter.classifications = favoriteFilter.classifications || [];
    angular.forEach(filterOptions.classifications, (model) => model.selected = favoriteFilter.classifications.includes(model.id));

    favoriteFilter.tematicas = favoriteFilter.tematicas || [];
    angular.forEach(filterOptions.tematicas, (model) => model.selected = favoriteFilter.tematicas.includes(model.id));

    favoriteFilter.categories = favoriteFilter.categories || [];
    favoriteFilter.subcategories = favoriteFilter.subcategories || {};

    angular.forEach(filterOptions.categories, (model) => {
      model.selected = favoriteFilter.categories.includes(model.id);
      model.expanded = false;
      favoriteFilter.subcategories[model.id] = favoriteFilter.subcategories[model.id] || [];
      angular.forEach(model.subcategories, (subModel) => subModel.selected = favoriteFilter.subcategories[model.id].includes(subModel.id));
    });

    filterOptions.uniqueStatus = getUniqueStatus(filterOptions.status);
    if (filterOptions.period) {
      filterOptions.period = favoriteFilter.period;
    }

    dataHolderFactory.updateFilterOptions(filterOptions);
    $rootScope.$emit('newFavoriteFilterSelected');
  };

  function getUniqueStatus(status) {
    const unique = {};
    const distinct = [];
    status.forEach(function(st) {
      if (!unique[st.name]) {
        distinct.push(st);
        unique[st.name] = true;
      }
    });
    return distinct;
  }
}

FavoriteFiltersController.$inject = ['$scope', '$rootScope', 'dataHolderFactory', 'localStorageService'];
export default FavoriteFiltersController;



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/favoriteFiltersController.js